// Teeno lead screens ke common hisse: header + loading/error shell, lead ka
// upar wala hissa (avatar, naam, company, source, status), aur icons.
import React from "react";
import HeaderBar from "../../HeaderBar/HeaderBar";
import styles from "./PounceLeadScreens.module.css";
import cardStyles from "../PounceLeadCard/PounceLeadCard.module.css";
import { initials, sourceLabel, statusOf } from "../pounceLeadShared";

const svg = (paths, size = 20) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {paths}
  </svg>
);

export const Icon = {
  phone: svg(<path d="M5 4h3l2 5-2.5 1.5a11 11 0 0 0 6 6L15 14l5 2v3a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2Z" />),
  mail: svg(<><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3.5 7l8.5 6 8.5-6" /></>),
  spark: svg(<path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3Z" />),
  calendar: svg(<><rect x="4" y="5" width="16" height="15" rx="3" /><path d="M8 3v4M16 3v4M4 10h16" /></>),
  clock: svg(<><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>),
  file: svg(<><path d="M14 3H6a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9l-6-6Z" /><path d="M14 3v6h6M8 13h8M8 17h5" /></>),
  mic: svg(<><rect x="9" y="3" width="6" height="11" rx="3" /><path d="M5 11a7 7 0 0 0 14 0M12 18v3" /></>),
  check: svg(<><circle cx="12" cy="12" r="9" /><path d="M8.5 12.5l2.3 2.3 4.7-4.8" /></>, 18),
  info: svg(<><circle cx="12" cy="12" r="9" /><path d="M12 11v5M12 8h.01" /></>),
  source: svg(<><circle cx="11" cy="11" r="7" /><path d="M16.5 16.5L21 21" /></>, 14),
  chevron: svg(<path d="M9 5l7 7-7 7" />, 18),
  redo: svg(<><path d="M20 12a8 8 0 1 1-2.3-5.7" /><path d="M20 4v5h-5" /></>, 18),
  ban: svg(<><circle cx="12" cy="12" r="9" /><path d="M5.6 5.6l12.8 12.8" /></>, 18),
  bolt: svg(<path d="M13 2L4 14h7l-1 8 9-12h-7l1-8Z" />),
  close: svg(<path d="M6 6l12 12M18 6L6 18" />),
};

/** HeaderBar + loading / error. `children(lead)` tabhi chalta hai jab lead aa jaye. */
export const ScreenShell = ({ title, lead, error, reload, children }) => (
  <div className={styles.page}>
    <div className={styles.headerSlot}>
      <HeaderBar title={title} />
    </div>
    {error && !lead ? (
      <div className={styles.state}>
        <p className={styles.muted}>{error}</p>
        <button type="button" className={styles.retryBtn} onClick={reload}>
          Try again
        </button>
      </div>
    ) : !lead ? (
      <div className={styles.stack} aria-busy="true" aria-label="Loading lead">
        <div className={styles.skeleton} />
        <div className={styles.skeleton} />
        <div className={styles.skeleton} />
      </div>
    ) : (
      <div className={styles.stack}>{children(lead)}</div>
    )}
  </div>
);

export const LeadHero = ({ lead }) => {
  const status = statusOf(lead);
  const source = sourceLabel(lead.source);
  return (
    <section className={styles.hero} aria-label="Lead">
      <span className={styles.heroAvatar} aria-hidden="true">
        {lead.name ? initials(lead.name) : "#"}
      </span>
      <span className={styles.heroText}>
        <h1 className={styles.heroName}>{lead.name || lead.phone}</h1>
        {lead.company && <span className={styles.heroCompany}>{lead.company}</span>}
        {source && (
          <span className={styles.heroSource}>
            {Icon.source}
            {source}
          </span>
        )}
      </span>
      <span className={`${cardStyles.status} ${cardStyles[status.tone]}`}>{status.label}</span>
    </section>
  );
};
